"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Group = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const constants_1 = require("../../../../constants");
const elements_1 = require("../../../../elements");
const Cell_1 = require("../components/Cell");
const consts_1 = require("../consts");
const useSchedule_1 = require("../useSchedule");
const X_PADDING = constants_1.theme.spacing[3];
const TitleRow = styled_1.default.tr({
    position: 'sticky',
    top: consts_1.HEADER_HEIGHT,
    zIndex: consts_1.composableZIndex.head,
});
const Body = (0, styled_1.default)(elements_1.Flex)({
    padding: `${constants_1.theme.spacing[2]}px ${X_PADDING}px`,
    width: '100%',
});
const Group = (props) => {
    const { columnCount } = (0, useSchedule_1.useSchedule)();
    const { isOpen, toggleOpen } = (0, useSchedule_1.useGroup)(props.id);
    if (props.hideGroup) {
        return null;
    }
    if (props.skipGroup) {
        return props.children;
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(TitleRow, { children: (0, jsx_runtime_1.jsx)(Cell_1.Cell, { style: { padding: 0, borderBottom: constants_1.theme.border.style.thinLight }, colSpan: columnCount, isTitle: true, children: (0, jsx_runtime_1.jsx)(Body, { style: {
                            background: props.isTeam ? constants_1.Color.GREY : constants_1.Color.BACKGROUND_GREY,
                        }, children: (0, jsx_runtime_1.jsxs)(elements_1.Clickable, { onClick: toggleOpen, styles: {
                                display: 'flex',
                                gap: 2,
                                width: 'fit-content',
                                alignItems: 'center',
                                position: 'sticky',
                                left: X_PADDING,
                            }, children: [(0, jsx_runtime_1.jsx)(elements_1.Icon, { name: isOpen ? 'ChevronDownIcon' : 'ChevronRightIcon' }), (0, jsx_runtime_1.jsx)(elements_1.Text, { children: props.title }), props.slot] }) }) }) }), isOpen && props.children] }));
};
exports.Group = Group;
